import { PARTICIPANT_ACTOR_KEY } from '@dadohr/shared/domainTypes/experience';
import styled from '@emotion/styled';
import { useTranslation } from '../../../../i18next';
import { LightMdToJsx } from '../../../../services/formatter';

const Container = styled('div')((p) => ({
  padding: p.theme.spacing(2),
  backgroundColor: p.theme.custom.colors.yellow.w100,
  marginBottom: p.theme.spacing(3)
}));

type TopBannerProps = {
  firstName: string;
  salutation: string;
  actor: string | undefined;
  title: string;
  orgName: string;
};

export const TopBanner = ({ d }: { d: TopBannerProps }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <div>
        <strong>
          {d.salutation || `${t('greetings.hi')} ${d.firstName}!`}
        </strong>
      </div>
      <LightMdToJsx component="div">
        {d.actor === PARTICIPANT_ACTOR_KEY
          ? t('standaloneApp.bookmarHint', {
              title: d.title,
              orgName: d.orgName
            })
          : t('standaloneApp.bookmarHintNotParticipant', {
              title: d.title,
              orgName: d.orgName,
              participantFirstName: d.firstName
            })}
      </LightMdToJsx>
    </Container>
  );
};
